<agpr-take-over-panel
    [id]="id"
    [header]="'Discover.distribution.personalizationWorkbench.header' | localize : { 
        'personalization': personalizationTypeLabelMap.get(personalizationType) }"
    [width]="70"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="close()"
>
    <div class="container">
        <div class="main">
            <agpr-scroll-panel
                #rightScrollPanel
                class="main-scroll"
            >
                <agpr-panel
                    id="generated_content"
                    class="mainPanel"
                    [header]="personalizationType === personalizationEnum.INTRO ? 
                        'Discover.distribution.personalizationWorkbench.intro': 'Discover.distribution.personalizationWorkbench.outro'"
                    [toggleable]="false"
                >
                    <agpr-rich-text-editor-ck
                        class="richTextEditor"
                        [ngClass]="{'richTextEditor-error': isTextExceedingLimit}"
                        [(ngModel)]="content"
                        (ngModelChange)="checkErrors()"
                        [richTextEditorConfig]="ckEditorConfig"
                    ></agpr-rich-text-editor-ck>
                    @if (isTextExceedingLimit) {
                        <agpr-form-message>
                            {{ 'Discover.distribution.personalizationWorkbench.maxLengthError' | localize }}
                        </agpr-form-message>
                    }
                </agpr-panel>
            </agpr-scroll-panel>
        </div>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_close_Button'"
            (click)="close()"
            [style]="buttonType.secondary"
            label="cancel"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_confirm_Button'"
            (click)="use()"
            [disabled]="isTextExceedingLimit"
            [style]="buttonType.primary"
            label="Discover.distribution.personalizationWorkbench.use"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
